import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
import { Typography } from "./Typography";
export var TooltipTypography = function(props) {
    return /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, props), {
        className: "f_t_tooltip"
    }));
};
